import { Link } from 'react-router-dom'
import { useI18n } from '../../i18n'

export default function ModelDetailHeader({ displayName, avatarUrl, error }) {
  const { t } = useI18n()
  return (
    <header className="model-detail-header">
      <div className="model-detail-header-top">
        <div className="model-detail-profile">
          {avatarUrl && <img src={avatarUrl} alt="" className="model-detail-avatar" />}
          <div>
            <h1 className="model-detail-title">{displayName || t('modelDetail.fallbackName')}</h1>
          </div>
        </div>
        <div className="model-detail-header-actions">
          {error && <div className="model-detail-error model-detail-error-inline">{error}</div>}
          <Link to="/" className="back-link">
            {t('modelDetail.backToList')}
          </Link>
        </div>
      </div>
    </header>
  )
}
